import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    width: 45,
    '&&&:before': {
      borderBottom: 'none',
    },
    '&&:after': {
      borderBottom: 'none',
    },
    fontSize: 16,
  },
  option: {
    fontSize: 16,
  },
}))

export default useStyles
